import DropzoneFormInput from './form/DropzoneFormInput';

const FileUpload = ({ title, onFilesChange }) => {
  return (
    <div>
      {title && <h6 className="mb-3" style={{ fontSize: '14px', fontWeight: '500' }}>{title}</h6>}
      <DropzoneFormInput
        className="py-5"
        iconProps={{
          icon: 'solar:cloud-upload-bold-duotone',
          height: 48,
          width: 48,
          className: 'mb-4 text-primary'
        }}
        text="Glissez vos images ici, ou cliquez pour parcourir"
        helpText={
          <span className="text-muted" style={{ fontSize: '12px' }}>
            (1600 x 1200 (4:3) recommandé. Formats PNG, JPG et GIF autorisés. Vous pouvez ajouter plusieurs images)
          </span>
        }
        showPreview={false}
        onFileUpload={onFilesChange}
      />
    </div>
  );
};

export default FileUpload;
